<template>
  <div class="admins-manager">
    <div class="admins-manager__block app__block">
      <h2 class="admin-manager__title">
        {{ 'admin-manager.title-add-admin' | globalize }}
      </h2>
      <permission-wrapper
        page-name="user"
        resource-name="user"
        action-name="update_foreign">
        <admin-manager-form />
      </permission-wrapper>
    </div>
  </div>
</template>

<script>
import AdminManagerForm from '@/vue/forms/AdminManagerForm'
import PermissionWrapper from '@/vue/common/permission-wrapper'

export default {
  name: 'admins-manager',
  components: {
    AdminManagerForm,
    PermissionWrapper,
  },
}
</script>

<style lang="scss" scoped>
.admins-manager__block {
  max-width: 64rem;
}

.admin-manager__title {
  margin-bottom: 2rem;
}
</style>
